let url = "";

if (process.env.NODE_ENV === 'development') {
	url = "http://localhost:8000";
} else if (process.env.REACT_APP_STAGE === 'homolog') {
	url = "https://dev-api.v3.fastfrete.com.br";
} else {
	url = "https://api.v3.fastfrete.com.br";
}

export const Constants = {
	url,
	baseUrl: url + '/api/web',
	baseUrlV2: url + '/api/v2/web/painel',
	baseUrlEmpresa: url + '/api/web/empresa',
	baseUrlPatio: url + '/api/web/patio',
	baseUrlEmbarcadora: url + "/api/web/embarcadora",
	baseUrlAdmin: url + "/api/web/admin",
	baseUrlTransportadora: url + "/api/web/transportadora",
	whatsappLink: "https://api.whatsapp.com/send?phone=5541998171280&text=Ol%C3%A1!%20",
};


